import { createSlice } from '@reduxjs/toolkit';
import getPathologyAIResults from '@custom/rtk-apis/microscopy/getPathologyAIResults';

const pathologyAIResultsSlice = createSlice({
  name: 'pathologyAIResults',
  initialState: {
    status: '',
    result: null as any,
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPathologyAIResults.pending, (state) => {
        state.loading = true;
        state.result = null;
      })
      .addCase(getPathologyAIResults.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload?.status || '';
        state.result = payload?.result || null;
      })
      .addCase(getPathologyAIResults.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default pathologyAIResultsSlice.reducer;
